import { sensorDataSchema } from '@si/types';
import { get } from '@si/utils';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from './queryKeys';

interface Params {
  projectId: string;
  sensorId: number;
  noRetry?: boolean;
  enabled?: boolean;
}

export function useSensorDataSingle({
  projectId,
  sensorId,
  noRetry = false,
  enabled = true,
}: Params) {
  const queryKey = queryKeys.getSensorDataSingle(projectId, sensorId);
  const url = `/projects/${projectId}/sensor/${sensorId}/sensor-data`;

  const { data, error, isLoading } = useQuery({
    queryKey,
    queryFn: () => get({ url, schema: sensorDataSchema }),
    enabled: enabled && !!projectId && !!sensorId,
    retry: noRetry ? false : 3,
  });

  return {
    sensorData: data,
    error,
    isLoading,
  };
}
